import React, { ReactNode } from 'react';
import { useChatContext } from './store/ChatContext';
import StageStepper from './StageStepper';
import BotHeaderTooltip from './BotHeaderTooltip';

interface Props {
  title: string;
  avatarEmoji?: string;
  extraActions?: ReactNode;
  onClose: () => void;
  closeLabel?: string;
  /** Optional per-step labels for the stage stepper. Falls back to English defaults. */
  stepperLabels?: { gathering?: string; selecting?: string; cart?: string; checkout?: string };
}

const STATUS_LABELS: Record<string, string> = {
  connected: 'Online',
  connecting: 'Connecting\u2026',
  error: 'Connection error',
  disconnected: 'Offline',
};

const ChatHeader: React.FC<Props> = ({
  title,
  avatarEmoji = '🤖',
  extraActions,
  onClose,
  closeLabel = 'Close',
  stepperLabels,
}) => {
  const { state } = useChatContext();
  return (
    <div className="bot-header">
      <div className="bot-header__top">
        <div className="bot-header__info">
          <div className="bot-header__avatar">{avatarEmoji}</div>
          <div>
            <div className="bot-header__title">{title}</div>
            <div className={`bot-header__status bot-header__status--${state.socketStatus}`}>
              {STATUS_LABELS[state.socketStatus] ?? 'Offline'}
            </div>
          </div>
        </div>
        <div className="bot-header__actions">
          {extraActions}
          <BotHeaderTooltip title={closeLabel}>
            <button className="bot-icon-btn" onClick={onClose} aria-label={closeLabel}>
              &#x2715;
            </button>
          </BotHeaderTooltip>
        </div>
      </div>
      <StageStepper stage={state.currentStage} labels={stepperLabels} />
    </div>
  );
};

export default ChatHeader;
